import { pageName } from '../constants';
import { convertToSnakeCase } from '../../helpers';

export const formBuilder = {
  fieldInteraction: (urlPath, field, fieldValue) => ({
    event_name: 'ui_interaction',
    page_name: `vodapay: business advance: opf: ${pageName[urlPath] || 'untracked'}`,
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    [convertToSnakeCase(field)]: fieldValue
  }),
  checkboxInteraction: (urlPath, field, fieldValue) => ({
    event_name: 'ui_interaction',
    page_name: `vodapay: business advance: opf: ${pageName[urlPath] || 'untracked'}`,
    page_url: window.location.href,
    page_section: 'business advance: opf',
    page_channel: 'vodapay: business advance: opf',
    page_subdomain: 'business advance: opf',
    page_type: 'website',
    [convertToSnakeCase(field)]: fieldValue
  })
};
